// `window.localStorage` no es fiable en todos los navegadores: en Safari/iOS
// en modo privado (y en algunos WebViews con el rastreo entre sitios
// bloqueado) `localStorage` puede ser directamente `null`
// (Sentry PLAYIUM-WEB-2V, `AuthContext.isSessionExpired`) o lanzar un
// `InvalidAccessError`/`SecurityError` al leer o escribir
// (PLAYIUM-WEB-3A, dentro del storage que usa el cliente de supabase-js para
// la sesión). Ninguno de los dos casos debe tumbar la app: sin storage
// persistente, la sesión se sigue resolviendo en memoria para esa pestaña.
//
// Wrapper mínimo: getItem/setItem/removeItem que nunca lanzan. Úsalo en vez
// de `localStorage` a pelo en cualquier código que corra en el navegador.
export const safeLocalStorage = {
  getItem(key: string): string | null {
    try {
      return typeof window === "undefined" ? null : window.localStorage?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      if (typeof window !== "undefined") window.localStorage?.setItem(key, value);
    } catch {
      // No hay storage persistente disponible: se ignora, la sesión sigue en memoria.
    }
  },
  removeItem(key: string): void {
    try {
      if (typeof window !== "undefined") window.localStorage?.removeItem(key);
    } catch {
      // Igual que en setItem: nada que limpiar si no hay storage.
    }
  },
};
